import { useI18n } from "@/hooks/useI18n";
import { dictionary } from "@/lib/i18n";
import {
  Server,
  HardDrive,
  Cpu,
  Lock,
  Phone,
  Network,
  BatteryCharging,
  FileCode,
} from "lucide-react";

const ICONS = {
  Server,
  HardDrive,
  Cpu,
  Lock,
  Phone,
  Network,
  BatteryCharging,
  FileCode,
};

export const Products = () => {
  const { lang } = useI18n();
  const data = dictionary.products;

  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 md:py-28 bg-white border-b border-[#E2E8F0]"
    >
      <div className="absolute inset-0 cads-grid opacity-40 [mask-image:radial-gradient(ellipse_70%_60%_at_50%_0%,#000_50%,transparent_100%)] pointer-events-none" />

      <div className="relative container mx-auto px-6 md:px-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-end mb-12">
          <div className="lg:col-span-7">
            <span
              data-testid="products-label"
              className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#1857D6]"
            >
              ▍ {data.label[lang]}
            </span>
            <h2
              data-testid="products-title"
              className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0A1933] leading-[1.1]"
              style={{ fontFamily: "Manrope, IBM Plex Sans, sans-serif" }}
            >
              {data.title[lang]}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base lg:text-lg text-[#475569] leading-relaxed">
              {data.subtitle[lang]}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {data.items.map((item, idx) => {
            const Icon = ICONS[item.icon] || Server;
            return (
              <article
                key={idx}
                data-testid={`product-card-${idx}`}
                className="group relative bg-white hover:bg-[#F5F8FC] transition-colors duration-300 p-6 lg:p-7 min-h-[230px] flex flex-col"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="h-11 w-11 flex items-center justify-center bg-gradient-to-br from-[#0F2756] to-[#1857D6] text-white">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-[10px] tracking-[0.3em] text-[#94A3B8] font-bold">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3
                  className="text-base lg:text-lg font-bold text-[#0A1933] leading-snug"
                  style={{ fontFamily: "Manrope, IBM Plex Sans, sans-serif" }}
                >
                  {item.title[lang]}
                </h3>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {item.vendors.map((v) => (
                    <span
                      key={v}
                      className="px-2 py-0.5 text-[11px] font-medium text-[#0F2756] border border-[#0F2756]/15 bg-white"
                    >
                      {v}
                    </span>
                  ))}
                </div>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#1857D6] group-hover:w-full transition-all duration-500" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Products;
